import React from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  Stack,
  IconButton,
  Typography,
  Button,
  Divider,
} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'react-i18next';
import { OpenInNew } from '@mui/icons-material';
import IDKeys from '../constants/idKeys';

/**
 * Default disclaimer modal for the application.
 * @param {object} props Props accepted by the component.
 * @param {boolean} props.open Whether the modal is visible.
 * @param {Function} props.closeModal Callback that is called when the user dismisses the modal.
 * @returns {React.FunctionComponent} React element that contains the modal.
 */
function DisclaimerModal({ open, closeModal }) {
  const [translate] = useTranslation('translation', {
    keyPrefix: 'disclaimer',
  });
  return (
    <Dialog id={IDKeys.DISCLAIMER} open={open} onClose={closeModal}>
      <DialogTitle sx={{ paddingX: 4, paddingY: 3 }}>
        <Stack direction="row" alignItems="center" gap={2}>
          <IconButton
            id={`${IDKeys.DISCLAIMER}InfoIconButton`}
            tabIndex={-1}
            disableRipple
            disableFocusRipple
          >
            <InfoOutlinedIcon />
          </IconButton>
          <Typography id={`${IDKeys.DISCLAIMER}TitleText`}>
            {translate('title')}
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent id={`${IDKeys.DISCLAIMER}Content`} sx={{ padding: 0 }}>
        <Stack gap={1} sx={{ marginX: 4, marginY: 4, padding: 0 }}>
          <Typography variant="body_sm">{translate('content-a')}</Typography>
          <Typography variant="body_sm">{translate('content-b')}</Typography>
          <a href={translate('privacyURL')} target="_blank" rel="noreferrer">
            <Stack
              direction="row"
              sx={{
                alignItems: 'center',
                gap: 1,
                px: 2,
                py: 3,
                width: '95%',
                justifyContent: 'space-between',
              }}
            >
              <Typography variant="body_sm">{translate('privacy')}</Typography>
              <OpenInNew fontSize="small" />
            </Stack>
          </a>
          <Divider />
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{
          marginX: 4,
          marginTop: 0,
          marginBottom: 4,
          padding: 0,
        }}
      >
        <Button id={`${IDKeys.DISCLAIMER}ConfirmButton`} onClick={closeModal}>
          <Typography variant="body_sm">{translate('accept')}</Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DisclaimerModal;
